<template>
  <div></div>
</template>

<script>
export default {
  name: 'Patients'
}
</script>

<style scoped></style>
